(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import styled from 'styled-components';
import { SPACE } from "../../constants/style.js"; // TODO: Move to containers
// +/-50px padding and margin to make consistent shadow to screen edge

var Header = styled('header').withConfig({
  displayName: "Header",
  componentId: "sc-1532rlb-0"
})(["box-shadow:0 0 50px rgba(0,0,0,0.1);margin:0 -50px;padding:", " calc(", " + 50px);z-index:100;"], SPACE.md, SPACE.xl);
var _default = Header;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Header, "Header", "/home/vsts/work/1/s/src/components/layout/Header.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/layout/Header.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();